import standardAction from '../../../utilities/standard-action';
import ActionTypes from '../constants/action-types';

export default function toggleDialog() {
  return standardAction(ActionTypes.TOGGLE_IMPORT_DIALOG);
}
